var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-list"},_vm._l((_vm.allBrands),function(item,index){return _c('div',{key:`tab-${index}`,staticClass:"tab-item",class:{ 'tab-active': item === _vm.brandSelect },on:{"click":function($event){_vm.brandSelect = item}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }